import { Content } from './index.styles';

interface Props {
  percent: number;
  type: 'green' | 'red';
}

export const ProgressIndicator = ({ percent, type }: Props) => {
  const clampPercent = (n: number) => Math.max(0, Math.min(n ?? 0, 100));

  const ringPercent = clampPercent(percent);
  const ringRadius = 9;
  const ringStrokeWidth = 1.8;
  const ringCircumference = 2 * Math.PI * ringRadius;
  const ringDashOffset = ringCircumference * (1 - ringPercent / 100);

  return (
    <Content
      aria-hidden="true"
      viewBox="0 0 24 24"
      $type={type}
    >
      <circle
        className="track"
        cx="12"
        cy="12"
        r={ringRadius}
        strokeWidth={ringStrokeWidth}
      />
      <circle
        className="progress"
        cx="12"
        cy="12"
        r={ringRadius}
        strokeWidth={ringStrokeWidth}
        strokeDasharray={ringCircumference}
        strokeDashoffset={ringDashOffset}
      />
    </Content>
  );
};
